import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import {reportSingleUpdateHistoryShape} from '../../../../../proptypes-shapes';
import ComplementaryInformation from '../ComplementaryInformation/ComplementaryInformation';

const FailedUpdateHistory = ({history, iconColor}) => {
  return (
    <Grid item>
      <Grid container gap={0.5} alignItems="center">
        <ErrorOutlineIcon sx={{fontSize: 14, color: iconColor}} />
        {history.numberOfAttempts && (
          <ComplementaryInformation>
            {history.numberOfAttempts} tentative{history.numberOfAttempts > 1 ? 's' : ''}
          </ComplementaryInformation>
        )}
      </Grid>
    </Grid>
  );
};

FailedUpdateHistory.propTypes = {
  history: reportSingleUpdateHistoryShape.isRequired,
  iconColor: PropTypes.string.isRequired
};

export default FailedUpdateHistory;
